import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { FiCheck } from 'react-icons/fi';

import { sendAnalyticsData } from '@/src/utils/analytics';

import type { IFeature2 } from '../home.interface';
import type { IProps } from './FeaturesPage';

/* One Feature */
const RenderFeatureContent = (feature: IFeature2, index: number) => {
  // Removed router hook, replaced button with Link below
  // const featureImage = [
  //   {
  //     imagePath: `${feature.imageUrl}/feature_${index}-2x.png`,
  //     imageWidth: 1024,
  //     alt: feature.alt,
  //   },
  // ];

  const defaultImage: string = feature.customImage
    ? feature.customImage
    : `${feature.imageUrl}/feature_${index}-1x.png`;

  const FeatureImage = feature.imageUrl
    ? `${feature.imageUrl}/feature_${index}-2x.png`
    : '';

  // const googleplayImage = [
  //   {
  //     imagePath: '/images/icons/appstoreredirect/android/google-play-2x.png',
  //     imageWidth: 1024,
  //     alt: 'Google Play',
  //   },
  // ];

  // const iosImage = [
  //   {
  //     imagePath: '/images/icons/appstoreredirect/ios/ios-store-2x.png',
  //     imageWidth: 1024,
  //     alt: 'App Store',
  //   },
  // ];

  if (feature.chip === 'On the Go') {
    return (
      <div
        className={`container mx-auto flex flex-col items-center justify-center p-2 md:flex-row md:gap-x-[4%] md:p-4 md:px-[2%] lg:gap-x-[10%] ${
          index % 2 !== 0 ? 'md:flex-row-reverse' : ''
        }`}
      >
        <div className="w-[80%] md:w-[50%] ">
          {/* <OptimisedImage data={featureImage} defaultImagePath={defaultImage} /> */}
          <Image
            src={FeatureImage || defaultImage}
            width={1024}
            height={1024}
            alt={feature.alt || 'image'}
          />
        </div>
        <div className="mt-4 flex flex-col text-center md:-mt-6 md:max-w-[46%] md:text-start lg:max-w-[33%]">
          <div className="mb-3 self-center rounded-2xl bg-[#f2faff] px-6 py-3 text-[15px] font-medium text-[#527B94] md:self-start">
            {feature.chip}
          </div>
          <div className="mt-4 text-xl font-medium text-[#3D3E40] md:text-2xl lg:text-4xl">
            {feature.title}
          </div>
          <div className="py-4 text-[15px] font-normal text-[#616366] md:w-[95%]">
            {feature.description}
          </div>
          {/* App Store Redirect */}
          <div className="mb-5 mt-3 flex items-center justify-center">
            <Link
              href="https://play.google.com/store/apps/details?id=io.ablespace.androidapp"
              className="mr-4 w-[50%] md:w-[45%]"
              onClick={() => sendAnalyticsData('PLAY_STORE_BUTTON_CLICKED')}
            >
              <Image
                src="/images/icons/appstoreredirect/android/native-google-play.svg"
                alt="AbleSpace Android App for Tracking IEP Goals, Data Collection and Student Assessment Reports"
                width={800}
                height={100}
              />

              {/* <OptimisedImage
                defaultImagePath="/images/icons/appstoreredirect/android/google-play-1x.png"
                data={googleplayImage}
              /> */}
            </Link>
            <Link
              href="https://apps.apple.com/us/app/ablespace-iep-goal-tracking/id1662372988"
              className="mr-5 w-[50%] md:w-[45%]"
              onClick={() => sendAnalyticsData('APP_STORE_BUTTON_CLICKED')}
            >
              <Image
                src="/images/icons/appstoreredirect/ios/native-ios-store.svg"
                alt="AbleSpace iOS App to automate Special Education Workflows"
                width={800}
                height={100}
              />
              {/* <OptimisedImage
                defaultImagePath="/images/icons/appstoreredirect/ios/ios-store-1x.png"
                data={iosImage}
              /> */}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (feature.chip === 'Schools/Districts') {
    return (
      <div
        className={`md: container mx-auto  mb-4 flex flex-col items-center justify-center rounded-3xl p-4 px-[4%] md:mb-16 md:w-[80%] md:flex-row md:gap-x-[3%] md:bg-blue-50 md:py-[4%] lg:gap-x-[4%] lg:px-[2%] lg:py-6 ${
          index % 2 !== 0 ? 'md:flex-row-reverse' : ''
        }`}
      >
        <div className="w-[80%] md:w-[45%]">
          {/* <OptimisedImage data={featureImage} defaultImagePath={defaultImage} /> */}
          <Image
            src={FeatureImage || defaultImage}
            width={1024}
            height={1024}
            alt={feature.alt || 'image'}
          />
        </div>
        <div className="mt-4 flex flex-col text-center md:-mt-6 md:max-w-[52%] md:text-start lg:max-w-[37%]">
          <div className="mb-3 self-center rounded-2xl bg-[#f2faff] px-4 py-3 text-[15px] font-medium text-[#527B94] md:self-start">
            {feature.chip}
          </div>
          <div className="mt-1 text-xl font-medium text-[#3D3E40] md:text-2xl lg:text-4xl">
            {feature.title}
          </div>
          <div className="w-[100%] py-4 text-[15px] font-normal text-[#616366] md:w-[85%]">
            {feature.description}
          </div>
          <Link
            href="/schools-and-districts"
            onClick={() => sendAnalyticsData('LEARN_MORE_BUTTON_CLICKED')}
            className={
              'mt-2 flex cursor-pointer items-center gap-x-2 self-center rounded-md border-2 border-[#318AE5] px-3 py-2 text-base font-medium text-[#318AE5] hover:bg-[#318AE5] hover:text-white md:self-start'
            }
          >
            Learn More <ChevronRightIcon className="stroke-3 h-4 w-4" />
          </Link>
        </div>
      </div>
    );
  }
  return (
    <div
      className={`container mx-auto flex flex-col items-center justify-center p-2 md:flex-row md:gap-x-[4%] md:p-4 md:px-[2%] lg:gap-x-[10%] 2xl:gap-x-[8%] ${
        index % 2 !== 0 ? 'md:flex-row-reverse' : ''
      }`}
    >
      <div className="w-[85%] md:w-[50%] 2xl:w-[35%] ">
        {/* <OptimisedImage data={featureImage} defaultImagePath={defaultImage} /> */}
        <Image
          src={FeatureImage || defaultImage}
          width={1024}
          height={1024}
          alt={feature.alt || 'image'}
        />
      </div>
      <div className="flex flex-col text-center md:-mt-8 md:max-w-[46%] md:text-start lg:max-w-[38%]">
        {feature.chip && (
          <div className="mb-3 self-center rounded-2xl bg-[#f2faff] px-4 py-3 text-[15px] font-medium text-[#527B94] md:self-start">
            {feature.chip}
          </div>
        )}
        <div className="ml-4 mt-1 w-[90%] whitespace-pre-line text-xl font-medium text-[#3D3E40] md:ml-0 md:w-[95%] md:text-2xl lg:text-4xl">
          {feature.isLineBreak
            ? feature.title.replace(' ', '\n')
            : feature.title}
        </div>
        <div className="py-4 text-[15px] font-normal text-[#616366] md:w-[86%] md:text-[18px]">
          {feature.description}
        </div>
        {feature.subPoints && (
          <p className="space-y-2 py-4 text-[15px] font-normal text-[#616366] md:w-[86%] md:text-[18px]">
            {feature.subPoints?.map((point, ind) => (
              <span key={ind} className="flex items-center gap-x-2 text-start">
                {/* <CheckIcon className="h-4 w-4 text-[#555659]" /> */}
                <FiCheck className="mr-1 inline h-5 w-4 shrink-0" />
                {point}
              </span>
            ))}
          </p>
        )}
      </div>
    </div>
  );
};
export const Feature2 = ({ feature, index }: IProps) => {
  return <>{RenderFeatureContent(feature, index)}</>;
};
